import React from 'react';
import {
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';

interface EmailInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiInputBase-input': {
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: '#bbb',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#90caf9',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#1e1e1e',
      borderRadius: theme.shape.borderRadius,
      '& fieldset': {
        borderColor: '#90caf9',
      },
      '&:hover fieldset': {
        borderColor: '#90caf9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#90caf9',
      },
    },
  },
}));

const EmailInput: React.FC<EmailInputProps> = ({ value, onChange }) => {
  return (
    <TextField
      variant="outlined"
      fullWidth
      label="E-mail"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <EmailIcon style={{ color: '#ccc' }} />
          </InputAdornment>
        )
      }}
    />
  );
};

export default EmailInput;
